<div class="row">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="w-100 d-flex align-items-center justify-content-center"
             style="min-height: 268px;" *ngIf="canUpload && !hasImg" id="dropzone"
             (drop)="dropHandler($event)" (dragover)="dragOverHandler($event)"
             (dragenter)="isDragOver = true" (dragleave)="isDragOver = false"
             [ngClass]="getDragAndDropClasses()">
          <h5 *ngIf="!isUploading">{{'lang.mediumExplorer.dragDropFiles' |
            translate}}</h5>
          <h5 *ngIf="isUploading">
            <sb-icon class="mr-2" icon="loadingBlockAnimation" [animationOptions]="{autoplay: true, loop:true}"
                     [style.color]="'#004F90'">
            </sb-icon>
            {{'lang.mediumExplorer.uploading' | translate}}
          </h5>
          <h5 *ngIf="false">
            <sb-icon class="mr-2" icon="setting" [animationOptions]="{autoplay: true, loop: true}"
                     [style.color]="'#004F90'">
            </sb-icon>
            {{'lang.mediumExplorer.processing' | translate}}
          </h5>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="hasImg">
      <div class="col" *ngIf="crop">
        <image-cropper [image]="image" [initialClipping]="initialClipping"
                       (clippingChange)="onClippingChange($event)">
        </image-cropper>
      </div>
      <div class="col" *ngIf="!crop">
        <img [src]="image?.clipped" style="width: 100%;"/>
      </div>
    </div>
  </div>

</div>
<div class="row mt-2">
  <div class="col">
    <div class="w-100 d-flex align-items-center justify-content-center">
      <ng-container *ngIf="!crop">
        <button *ngIf="canUpload" (click)="openFilePicker()" class="btn btn-primary mr-2">
          <sb-icon icon="upload"></sb-icon>
        </button>
        <button *ngIf="canDelete" (click)="deleteMedium()" class="btn btn-danger mr-2">
          <sb-icon icon="trash"></sb-icon>
        </button>
        <button *ngIf="hasImg" (click)="crop = true" class="btn btn-primary mr-2">
          <sb-icon icon="crop"></sb-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="crop">
        <button *ngIf="clipping" (click)="apply()" class="btn btn-success mr-2">
          <sb-icon icon="checked"></sb-icon>
        </button>
        <button (click)="cancel()" class="btn btn-primary mr-2">
          <sb-icon icon="cancel"></sb-icon>
        </button>
      </ng-container>
    </div>
  </div>
</div>

<input #filePicker type="file" style="display:none;" (change)="filePicked()">
